/* SP-SDE draft-only direct-offer reveal. Prices come only from server-rendered
   selected-variant Liquid inside the native Shopify price update container. */
(() => {
  'use strict';
  if (window.__spzDirectOfferRevealV1) return;
  window.__spzDirectOfferRevealV1 = true;

  function setOpen(offer, isOpen) {
    if (!offer) return;
    const button = offer.querySelector('[data-spz-direct-offer-trigger]');
    const detail = offer.querySelector('[data-spz-direct-offer-details]');
    if (!button || !detail) return;
    detail.hidden = !isOpen;
    button.setAttribute('aria-expanded', String(isOpen));
    button.textContent = isOpen ? 'Hide your direct-purchase offer' : 'Reveal your direct-purchase offer';
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-spz-direct-offer-trigger]');
    if (!button) return;
    const offer = button.closest('[data-spz-direct-offer]');
    const root = button.closest('product-info');
    if (!offer || !root) return;
    const isOpen = button.getAttribute('aria-expanded') !== 'true';
    root.dataset.spzDirectOfferOpen = String(isOpen);
    setOpen(offer, isOpen);
  });

  /* Native product-info.js replaces #price-SECTION with server-rendered
     selected-variant HTML, then publishes this theme's variantChange event. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      if (!sectionId) return;
      const root = Array.from(document.querySelectorAll('product-info'))
        .find((node) => node.dataset.section === String(sectionId));
      if (!root) return;
      setOpen(root.querySelector('[data-spz-direct-offer]'), root.dataset.spzDirectOfferOpen === 'true');
    });
  }
})();
